// Components
import { IconTracklibLogoSymbol } from '@tracklib/kit'

// Utils
import styles from './header.css'

type HeaderProps = {
  headerTitle: string
}

const Header = (props: HeaderProps): JSX.Element => {
  const { headerTitle } = props
  const title = headerTitle.toUpperCase()

  return (
    <header className={styles.header}>
      <IconTracklibLogoSymbol className={styles.icon} />
      <div className={styles.title}>{title}</div>
      <div className={styles.headerSpacer}>&nbsp;</div>
    </header>
  )
}

export default Header
